import React from 'react';
import { Card } from 'react-bootstrap';
import { CustomImageHandler } from '../../../../../../../shared/components/CustomImageHandler';
import { TextField } from '@mui/material';
import { copyToClipboard, getSocialIcons } from '../../../../../../../shared/functions/Functions';
import { FaCopy } from 'react-icons/fa';

interface IExternalSearchProfileInfoProps {
    handle: string;
    photoUrl: string;
    href?: string;
    email?: string;
    socialIcon?: string;
}

export function ExternalSearchProfileInfo({
    handle,
    email,
    photoUrl,
    href,
    socialIcon,
}: IExternalSearchProfileInfoProps) {
    return (
        <Card className="d-none d-xl-flex">
            <Card.Body className="d-flex flex-column align-items-center">
                <CustomImageHandler photoPath={photoUrl} altTag="User Profile" classes="profile-image cursor-pointer" />
                <div className="mt-3 mb-3 d-flex align-items-center">
                    {getSocialIcons({
                        iconPath: socialIcon,
                    })}

                    <a target="_blank" className="d-flex align-items-center" href={href} rel="noreferrer">
                        <span className="ml-1 mb-0">{handle && `@${handle}`}</span>
                    </a>
                </div>
                {email && (
                    <div className="d-flex align-items-center mb-3">
                        <TextField
                            value={email}
                            name="handle"
                            label="Email"
                            variant="outlined"
                            size="small"
                            className="w-100"
                        />
                        <div
                            style={{ marginLeft: '-1.5rem', zIndex: 1 }}
                            className="cursor-pointer"
                            onClick={() => copyToClipboard(email ?? '')}
                        >
                            <FaCopy className="text-muted" size={20} />
                        </div>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
}
